import React from 'react';
import { useGoodsPromotionComponents } from '../../queries/useGoodsPromotionComponents';
import {
  Carousel,
  Colors,
  convertHexToBackgroundColorKeys,
  convertHexToContentColorKeys,
  Flex,
  IconChevronRight,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import type { PromotionsBanner } from 'shared/src/api';
import { bridge, isNil, isNotNil } from 'shared/src/utils';
import { RemainTimer } from './components/RemainTimer';
import { useLogClickShortBanner } from './hooks/useLogClickShortBanner';
const GoodsPromotionsContent = () => {
  const { data } = useGoodsPromotionComponents('GOODS_DETAIL');
  const { width: screenWidth } = useScreenSize();
  const logClickShortBanner = useLogClickShortBanner();

  if (isNil(data.component)) return null;

  return (
    <Carousel<PromotionsBanner>
      data={data.component.banners}
      vertical={false}
      width={screenWidth}
      autoPlay={data.component.banners.length > 1}
      autoPlayInterval={3000}
      height={32}
      renderItem={({ item }) => (
        <Flex.Row
          backgroundColor={
            convertHexToBackgroundColorKeys(item.item.background_color) ??
            undefined
          }
          backgroundColorValue={
            convertHexToBackgroundColorKeys(item.item.background_color)
              ? undefined
              : item.item.background_color
          }
          alignItems={'center'}
          justifyContent={'center'}
          padding={{ horizontal: 16 }}
          height={32}
          gap={2}
          onPress={() => {
            if (isNotNil(item.item.deeplink)) {
              logClickShortBanner(item);
              const { deeplink } = item.item;
              bridge.openDeeplink(deeplink);
            }
          }}
        >
          <Flex.Row gap={4} alignItems={'center'}>
            <RemoteImage uri={item.item.icon} width={20} height={20} />
            <Typography
              type={'subtitle4'}
              color={
                convertHexToContentColorKeys(item.item.text_color) ?? undefined
              }
              rawColor={
                convertHexToContentColorKeys(item.item.text_color)
                  ? undefined
                  : item.item.text_color
              }
            >
              {item.item.text}
            </Typography>
            {isNotNil(item.item.timer) && (
              <RemainTimer timer={item.item.timer} />
            )}
          </Flex.Row>
          {isNotNil(item.item.deeplink) && (
            <IconChevronRight
              size={16}
              fill={item.item.arrow_color ?? Colors.content_tertiary}
            />
          )}
        </Flex.Row>
      )}
    />
  );
};

export const GoodsPromotions = () => {
  return (
    <React.Suspense fallback={<></>}>
      <GoodsPromotionsContent />
    </React.Suspense>
  );
};
